// Exercise
export const SHOW_EXERCISE = 'SHOW_EXERCISE';
export const HIDE_COMPLETION_PANE = 'HIDE_COMPLETION_PANE';
// Hint
export const SHOW_HINT = 'SHOW_HINT';
// Solution
export const TAKE_SOLUTION_REQUESTED = 'TAKE_SOLUTION_REQUESTED';
export const TAKE_SOLUTION_FAILED = 'TAKE_SOLUTION_FAILED';
export const TAKE_SOLUTION_COMPLETED = 'TAKE_SOLUTION_COMPLETED';
export const CHECK_EXERCISE_REQUESTED = 'CHECK_EXERCISE_REQUESTED';
export const CHECK_EXERCISE_COMPLETED = 'CHECK_EXERCISE_COMPLETED';
// MCE
export const SELECT_MULTIPLE_CHOICE_EXERCISE_OPTION = 'SELECT_MULTIPLE_CHOICE_EXERCISE_OPTION';
export const EXERCISE_ENTITY_UPDATED = 'EXERCISE_ENTITY_UPDATED';
export const USER_WORKBOOK_UPDATED = 'USER_WORKBOOK_UPDATED';
export const USER_WORKBOOK_DELETED = 'USER_WORKBOOK_DELETED';